import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5 8.4c0 .4-.3.8-.8.8l-1.5.2c-.5 0-.8.3-.9.8a28.3 28.3 0 0 0 0 6.3c0 .4.4.8.9.8a47 47 0 0 0 9.6 0c.5 0 .8-.4.9-.8a28.3 28.3 0 0 0 0-6.3c0-.5-.4-.8-.9-.8l-1.5-.2a.8.8 0 1 1 0-1.6l1.7.1c1.2.1 2.2 1 2.3 2.3a30 30 0 0 1 0 6.7A2.6 2.6 0 0 1 15 19a48.7 48.7 0 0 1-10 0c-1.2-.2-2.2-1-2.3-2.3a30 30 0 0 1 0-6.7A2.6 2.6 0 0 1 5 7.7l1.6-.1c.5 0 .9.3.9.8",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.7 5.2A.8.8 0 0 1 6.5 4l3-3c.2-.2.8-.2 1 0l3 3a.8.8 0 1 1-1.2 1.2l-1.5-1.5v8a.8.8 0 0 1-1.6 0v-8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }